/* Saved texture: the texture a shopper picks follows them to every product page that sells it (Parth, 6 Oct 2026).
   Galaxy picked on a camera skin opens the lens page on Galaxy; carbon fibre on one iPhone opens the next iPhone on
   carbon fibre, even when that swatch is not the first one.

   Saved when the shopper
     - taps a texture (product page swatch, the phone texture drawer, quick-add, a texture swatch on a product card),
     - adds to cart (the texture of the item added),
     - arrives from outside the site on a link naming a variant (Google Shopping, ads) or a ?texture= link.
   Never saved by our own links (collection cards, device switcher, related products, cart), by "None" (cases
   without a skin), or by the page opening on its default texture.

   Applied on every product page / quick-add whose Texture (or Skin, on cases) option has that value, ignoring
   capitals and punctuation, sold out or not (unless the template hides sold-out swatches). New textures need no
   setup: names are read from each product. Ladder add-on cards follow the main texture too.

   Storage: 30 days in this browser where Shopify's customer privacy API says preferences may be stored (no consent
   needed in the visitor's region, or the visitor accepted); otherwise only for this visit (tab session). The value is
   a texture name only and never leaves the browser. */
(function () {
  'use strict';
  if (window.CapesTexture) { return; }

  var KEY = 'capes_texture';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var OPTION_NAMES = ['texture', 'skin'];
  var restoring = false;

  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/fiber/g, 'fibre').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* ---- storage + consent -------------------------------------------------------------------- */
  function privacy() { return window.Shopify && window.Shopify.customerPrivacy; }
  function persistAllowed() {
    var cp = privacy();
    if (!cp) { return false; }
    try {
      if (typeof cp.preferencesProcessingAllowed === 'function') { return !!cp.preferencesProcessingAllowed(); }
      if (typeof cp.userCanBeTracked === 'function') { return !!cp.userCanBeTracked(); }
    } catch (e) { /* treat as not allowed */ }
    return false;
  }
  function read(store) {
    try {
      var r = JSON.parse(store.getItem(KEY));
      if (r && r.v && typeof r.at === 'number' && Date.now() - r.at < MAX_AGE) { return r; }
    } catch (e) { /* storage blocked or empty */ }
    return null;
  }
  function write(store, rec) { try { store.setItem(KEY, JSON.stringify(rec)); } catch (e) { /* blocked */ } }
  function drop(store) { try { store.removeItem(KEY); } catch (e) { /* blocked */ } }
  function local() { try { return window.localStorage; } catch (e) { return null; } }
  function session() { try { return window.sessionStorage; } catch (e) { return null; } }

  function load() {
    var a = local() && read(local()), b = session() && read(session());
    var best = a && b ? (a.at >= b.at ? a : b) : (a || b);
    return best ? best.v : null;
  }
  function save(value) {
    var n = norm(value);
    if (!n || n === 'none') { return; }
    var rec = { v: String(value).trim(), at: Date.now() };
    if (session()) { write(session(), rec); }
    if (local() && persistAllowed()) { write(local(), rec); }
  }
  /* Once the consent library is in: copy this visit's pick to the 30-day store when allowed, remove it when not. */
  function syncConsent() {
    if (!privacy() || !local()) { return; }
    if (persistAllowed()) {
      var s = session() && read(session()), l = read(local());
      if (s && (!l || s.at > l.at)) { write(local(), s); }
    } else {
      drop(local());
    }
  }
  function loadConsent() {
    if (privacy()) { syncConsent(); return; }
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: function (err) { if (!err) { syncConsent(); } } }]);
    } catch (e) { /* no consent library: this visit only */ }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);

  /* ---- product helpers ---------------------------------------------------------------------- */
  function textureIndex(product) {
    var opts = (product && product.options) || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : opts[i] && opts[i].name;
      if (OPTION_NAMES.indexOf(norm(name)) > -1) { return i; }
    }
    return -1;
  }
  function currentTexture(picker) {
    var idx = textureIndex(picker.product), v = picker.selectedVariant;
    return idx > -1 && v ? v.options[idx] : null;
  }
  function isMain(picker) { return picker.hasAttribute('update-url'); }
  function mainPicker() { return document.querySelector('variant-picker[update-url]'); }

  /* Centre the chosen swatch in a horizontally scrolling row without moving the page. */
  function reveal(input) {
    var label = (input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]')) || input.parentElement;
    for (var el = label && label.parentElement; el && el !== document.body; el = el.parentElement) {
      if (el.scrollWidth > el.clientWidth + 4 && /(auto|scroll)/.test(getComputedStyle(el).overflowX)) {
        var lr = label.getBoundingClientRect(), cr = el.getBoundingClientRect();
        el.scrollLeft += (lr.left + lr.width / 2) - (cr.left + cr.width / 2);
        return;
      }
    }
  }

  /* Select a texture on a picker the same way a tap would (price, photos, What's Included, ladder all follow).
     Returns true when the picker now shows that texture. */
  function apply(picker, value) {
    var product = picker.product, idx = textureIndex(product), want = norm(value);
    if (idx < 0 || !want) { return false; }
    if (norm(currentTexture(picker)) === want) { return true; }
    /* Sold-out textures are applied too (Parth, 6 Oct 2026: stock comes back any time) — except where the template's
       "Hide sold out variants" setting hides that swatch from everyone; the saved texture is never erased, so it
       applies again on its own once restocked. */
    var hides = picker.hasAttribute('hide-sold-out-variants'), exact = null;
    product.variants.some(function (v) {
      if ((v.available || !hides) && norm(v.options[idx]) === want) { exact = v.options[idx]; return true; }
      return false;
    });
    if (!exact) { return false; }
    var row = picker.optionSelectors && picker.optionSelectors[idx];
    if (!row) { return false; }
    var name = 'option' + (idx + 1);
    var input = row.querySelector('input[type="radio"][name="' + name + '"][value="' + CSS.escape(exact) + '"]');
    var select = !input && row.querySelector('select[name="' + name + '"]');
    if (!input && !select) { return false; }
    restoring = true;
    window.__capesPreselecting = true; /* the jump-to-photo handler stands down: not a customer pick */
    try {
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      else { select.value = exact; select.dispatchEvent(new Event('change', { bubbles: true })); }
    } finally {
      restoring = false;
      window.__capesPreselecting = false;
    }
    if (input) { reveal(input); }
    return norm(currentTexture(picker)) === want;
  }

  /* ---- ladder add-on cards follow the texture ------------------------------------------------ */
  function optionTexture(sel, opt) {
    var pos = parseInt(sel.getAttribute('data-tex-pos'), 10);
    if (!pos) { return null; }
    return (opt.textContent || '').split(' / ')[pos - 1] || null;
  }
  function optionRest(sel, opt) {
    var pos = parseInt(sel.getAttribute('data-tex-pos'), 10);
    return (opt.textContent || '').split(' / ').filter(function (_, i) { return i !== pos - 1; }).join(' / ').trim();
  }
  function followLadder(value) {
    var want = norm(value);
    if (!want || want === 'none') { return; }
    document.querySelectorAll('select[data-cbl-var][data-tex-pos]').forEach(function (sel) {
      if (!parseInt(sel.getAttribute('data-tex-pos'), 10)) { return; } /* add-on has no texture option */
      if (sel.hasAttribute('data-cbl-picked')) { return; } /* the shopper chose this card's option themselves */
      var cur = sel.selectedOptions[0];
      if (!cur || norm(optionTexture(sel, cur)) === want) { return; }
      var rest = optionRest(sel, cur), same = null, any = null;
      Array.prototype.forEach.call(sel.options, function (o) {
        if (norm(optionTexture(sel, o)) !== want) { return; }
        if (!any) { any = o; }
        if (!same && optionRest(sel, o) === rest) { same = o; }
      });
      var pick = same || any;
      if (!pick) { return; }
      restoring = true;
      try { sel.value = pick.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      finally { restoring = false; }
    });
  }

  /* ---- arrival: apply the saved texture, or save the one an outside link chose ---------------- */
  function navType() {
    try { var n = performance.getEntriesByType('navigation')[0]; return n ? n.type : ''; } catch (e) { return ''; }
  }
  function fromOutside() {
    if (navType() === 'back_forward') { return false; }
    var r = document.referrer;
    if (!r) { return true; }
    try { return new URL(r).hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, ''); }
    catch (e) { return true; }
  }

  function onReady(picker) {
    if (!picker || !picker.product || picker.__capesTexture) { return; }
    picker.__capesTexture = true;
    var main = isMain(picker), idx = textureIndex(picker.product);
    if (idx < 0) {
      if (main) { followLadder(load()); }
      return;
    }
    if (main) {
      var params = new URLSearchParams(location.search);
      var asked = params.get('texture');
      if (asked) {
        /* drop ?texture= from the address bar once read, so a reload never undoes a later pick */
        try { var u = new URL(location.href); u.searchParams.delete('texture'); history.replaceState(history.state, '', u.toString()); }
        catch (e) { /* old browser: harmless */ }
      }
      if (asked && apply(picker, asked.replace(/[-_+]+/g, ' '))) {
        save(currentTexture(picker));
      } else if (params.get('variant') && fromOutside()) {
        save(currentTexture(picker));
      } else {
        var saved = load();
        if (saved) { apply(picker, saved); }
      }
      followLadder(currentTexture(picker));
    } else {
      var s = load();
      if (s) { apply(picker, s); }
    }
  }

  document.addEventListener('variant-picker:ready', function (e) { onReady(e.target); });
  function scan() { document.querySelectorAll('variant-picker').forEach(function (p) { if (p.capesReady) { onReady(p); } }); }

  /* ---- saving on the shopper's own actions --------------------------------------------------- */
  var infoPick = false;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || restoring) { return; }
    /* ladder card dropdown, directly or through its info pop-up: stop following the main texture for that card */
    if (t.matches && t.matches('[data-cbl-info-var]')) { infoPick = e.isTrusted; return; }
    if (t.matches && t.matches('[data-cbl-var]')) {
      if (e.isTrusted || infoPick) { t.setAttribute('data-cbl-picked', ''); }
      infoPick = false;
      return;
    }
    if (!e.isTrusted || window.__capesPreselecting) { return; }
    var picker = t.closest && t.closest('variant-picker');
    if (picker && picker.product && /^option\d+$/.test(t.name || '')) {
      if (parseInt(t.name.slice(6), 10) - 1 === textureIndex(picker.product)) { save(t.value); }
      return;
    }
    /* product cards only show swatches for the Texture option (theme label "Texture") */
    var card = t.closest && t.closest('product-card');
    if (card && (t.type === 'radio' || (t.matches && t.matches('.product-card__variant-select')))) {
      if (t.value && norm(t.value) !== 'select texture') { save(t.value); }
    }
  }, true);

  /* The phone texture drawer relays a tap by clicking the real swatch, which is not a "trusted" change. */
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) { return; }
    var item = e.target.closest && e.target.closest('[data-cpx-vd-value]');
    var picker = item && item.closest('variant-picker');
    if (!picker || !picker.product) { return; }
    var value = item.getAttribute('data-cpx-vd-value'), idx = textureIndex(picker.product);
    if (idx > -1 && picker.querySelector('input[type="radio"][name="option' + (idx + 1) + '"][value="' + CSS.escape(value) + '"]')) {
      save(value);
    }
  }, true);

  /* Add to cart (inline button, sticky bar, quick-add): save the texture of the variant being added. */
  document.addEventListener('submit', function (e) {
    var form = e.target, formId = form && form.getAttribute && form.getAttribute('id');
    if (!formId) { return; }
    var picker = document.querySelector('variant-picker[form="' + CSS.escape(formId) + '"]');
    if (picker && picker.product) { save(currentTexture(picker)); }
  }, true);

  /* main product's texture changes → ladder cards follow */
  document.addEventListener('variant:change', function (e) {
    var d = e.detail || {}, main = mainPicker();
    if (!main || !d.product || !d.variant || e.target !== document.forms[main.getAttribute('form')]) { return; }
    var idx = textureIndex(d.product);
    if (idx > -1) { followLadder(d.variant.options[idx]); }
  });

  function start() {
    loadConsent();
    scan();
    if (!mainPicker()) { followLadder(load()); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }

  window.CapesTexture = { load: load, save: save, norm: norm };
})();
